import {
  DealerIndicatorValues,
  DealerIndicatorValuesReport,
} from "~/schemas/generated/graphql";

export const parseIndicatorReportToView = (
  report: DealerIndicatorValuesReport,
  items: DealerIndicatorValues[],
  dealerMetaInfoKeys: { [key: string]: string }
) => {
  const dealersCollection = items.map((dealer) => {
    return {
      dName: "",
      dValues: dealer.Values,
      dRegMans: dealer.RegMen,
      dMeta: {
        ...Object.keys(dealerMetaInfoKeys).reduce((acc, key) => {
          return { ...acc, [key]: dealer.Dealer[key] };
        }, {}),
      },
    };
  });

  const indicatorsCollection = report.IndicatorReport.Indicators;
  const regMenCollection = report.RegMen;
  const metadataCollection = dealerMetaInfoKeys;

  return {
    dealersCollection,
    indicatorsCollection,
    regMenCollection,
    metadataCollection,
  };
};
